"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _ApiClient = _interopRequireDefault(require("../ApiClient"));

var _AuthenticateRequest = _interopRequireDefault(require("../model/AuthenticateRequest"));

var _AuthenticateUpdateResponse = _interopRequireDefault(require("../model/AuthenticateUpdateResponse"));

var _Customer = _interopRequireDefault(require("../model/Customer"));

var _Error = _interopRequireDefault(require("../model/Error"));

var _Figure = _interopRequireDefault(require("../model/Figure"));

var _Menu = _interopRequireDefault(require("../model/Menu"));

var _MenuGroup = _interopRequireDefault(require("../model/MenuGroup"));

var _MetricLatest = _interopRequireDefault(require("../model/MetricLatest"));

var _Module = _interopRequireDefault(require("../model/Module"));

var _Org = _interopRequireDefault(require("../model/Org"));

var _TestCode = _interopRequireDefault(require("../model/TestCode"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

/**
* Default service.
* @module api/DefaultApi
* @version 0.2.0
*/
var DefaultApi = /*#__PURE__*/function () {
  /**
  * Constructs a new DefaultApi. 
  * @alias module:api/DefaultApi
  * @class
  * @param {module:ApiClient} [apiClient] Optional API client implementation to use,
  * default to {@link module:ApiClient#instance} if unspecified.
  */
  function DefaultApi(apiClient) {
    _classCallCheck(this, DefaultApi);

    this.apiClient = apiClient || _ApiClient["default"].instance;
  }
  /**
   * Callback function to receive the result of the authenticate operation.
   * @callback module:api/DefaultApi~authenticateCallback
   * @param {String} error Error message, if any.
   * @param {module:model/AuthenticateUpdateResponse} data The data returned by the service call.
   * @param {String} response The complete HTTP response.
   */

  /**
   * Authenticate user login
   * null
   * @param {Object} opts Optional parameters
   * @param {module:model/AuthenticateRequest} opts.authenticateRequest 
   * @param {module:api/DefaultApi~authenticateCallback} callback The callback function, accepting three arguments: error, data, response
   * data is of type: {@link module:model/AuthenticateUpdateResponse}
   */


  _createClass(DefaultApi, [{
    key: "authenticate",
    value: function authenticate(opts, callback) {
      opts = opts || {};
      var postBody = opts['authenticateRequest'];
      var pathParams = {};
      var queryParams = {};
      var headerParams = {};
      var formParams = {};
      var authNames = ['bearerAuth'];
      var contentTypes = ['application/json'];
      var accepts = ['application/json'];
      var returnType = _AuthenticateUpdateResponse["default"];
      return this.apiClient.callApi('/auth/login', 'POST', pathParams, queryParams, headerParams, formParams, postBody, authNames, contentTypes, accepts, returnType, null, callback);
    }
    /**
     * Callback function to receive the result of the getAnalyzers operation.
     * @callback module:api/DefaultApi~getAnalyzersCallback
     * @param {String} error Error message, if any.
     * @param {Array.<module:model/Module>} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * Gets a list of analyzers given an id
     * Returns a list of analyzers
     * @param {String} vasid 
     * @param {module:api/DefaultApi~getAnalyzersCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link Array.<module:model/Module>}
     */

  }, {
    key: "getAnalyzers",
    value: function getAnalyzers(vasid, callback) {
      var postBody = null; // verify the required parameter 'vasid' is set

      if (vasid === undefined || vasid === null) {
        throw new _Error["default"]("Missing the required parameter 'vasid' when calling getAnalyzers");
      }

      var pathParams = {
        'vasid': vasid
      };
      var queryParams = {};
      var headerParams = {};
      var formParams = {};
      var authNames = ['bearerAuth'];
      var contentTypes = [];
      var accepts = ['application/json'];
      var returnType = [_Module["default"]];
      return this.apiClient.callApi('/v0/analyzers/{vasid}', 'GET', pathParams, queryParams, headerParams, formParams, postBody, authNames, contentTypes, accepts, returnType, null, callback);
    }
    /**
     * Callback function to receive the result of the getFigure operation.
     * @callback module:api/DefaultApi~getFigureCallback
     * @param {String} error Error message, if any.
     * @param {module:model/Figure} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * Gets a specific figure given a code/id
     * Returns a figure
     * @param {String} code 
     * @param {String} vasid 
     * @param {Object} opts Optional parameters
     * @param {Object.<String, {String: Object}>} opts.data 
     * @param {module:api/DefaultApi~getFigureCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link module:model/Figure}
     */

  }, {
    key: "getFigure",
    value: function getFigure(code, vasid, opts, callback) {
      opts = opts || {};
      var postBody = null; // verify the required parameter 'code' is set

      if (code === undefined || code === null) {
        throw new _Error["default"]("Missing the required parameter 'code' when calling getFigure");
      } // verify the required parameter 'vasid' is set


      if (vasid === undefined || vasid === null) {
        throw new _Error["default"]("Missing the required parameter 'vasid' when calling getFigure");
      }

      var pathParams = {
        'code': code,
        'vasid': vasid
      };
      var queryParams = {
        'data': opts['data']
      };
      var headerParams = {};
      var formParams = {};
      var authNames = ['bearerAuth'];
      var contentTypes = [];
      var accepts = ['application/json'];
      var returnType = _Figure["default"];
      return this.apiClient.callApi('/v0/figures/{code}/{vasid}', 'GET', pathParams, queryParams, headerParams, formParams, postBody, authNames, contentTypes, accepts, returnType, null, callback);
    }
    /**
     * Callback function to receive the result of the getMetricLatest operation.
     * @callback module:api/DefaultApi~getMetricLatestCallback
     * @param {String} error Error message, if any.
     * @param {module:model/MetricLatest} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * Gets a specific gauge value and change given an id
     * Returns a gauge value and change from Management/Operations level.
     * @param {module:model/null} UNKNOWN_PARAMETER_NAME 
     * @param {module:api/DefaultApi~getMetricLatestCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link module:model/MetricLatest}
     */

  }, {
    key: "getMetricLatest",
    value: function getMetricLatest(UNKNOWN_PARAMETER_NAME, callback) {
      var postBody = null; // verify the required parameter 'UNKNOWN_PARAMETER_NAME' is set

      if (UNKNOWN_PARAMETER_NAME === undefined || UNKNOWN_PARAMETER_NAME === null) {
        throw new _Error["default"]("Missing the required parameter 'UNKNOWN_PARAMETER_NAME' when calling getMetricLatest");
      }

      var pathParams = {
        'id': UNKNOWN_PARAMETER_NAME
      };
      var queryParams = {};
      var headerParams = {};
      var formParams = {};
      var authNames = ['bearerAuth'];
      var contentTypes = [];
      var accepts = ['application/json'];
      var returnType = _MetricLatest["default"];
      return this.apiClient.callApi('/v0/metrics/{id}/latest', 'GET', pathParams, queryParams, headerParams, formParams, postBody, authNames, contentTypes, accepts, returnType, null, callback);
    }
    /**
     * Callback function to receive the result of the getMetricValues operation.
     * @callback module:api/DefaultApi~getMetricValuesCallback
     * @param {String} error Error message, if any.
     * @param {Array.<Number>} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * Gets specific metric data given an id
     * Returns an array of values from Management/Operations level.
     * @param {module:model/null} UNKNOWN_PARAMETER_NAME 
     * @param {module:api/DefaultApi~getMetricValuesCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link Array.<Number>}
     */

  }, {
    key: "getMetricValues",
    value: function getMetricValues(UNKNOWN_PARAMETER_NAME, callback) {
      var postBody = null; // verify the required parameter 'UNKNOWN_PARAMETER_NAME' is set

      if (UNKNOWN_PARAMETER_NAME === undefined || UNKNOWN_PARAMETER_NAME === null) {
        throw new _Error["default"]("Missing the required parameter 'UNKNOWN_PARAMETER_NAME' when calling getMetricValues");
      }

      var pathParams = {
        'id': UNKNOWN_PARAMETER_NAME
      };
      var queryParams = {};
      var headerParams = {};
      var formParams = {};
      var authNames = ['bearerAuth'];
      var contentTypes = [];
      var accepts = ['application/json'];
      var returnType = ['Number'];
      return this.apiClient.callApi('/v0/metrics/{id}/values', 'GET', pathParams, queryParams, headerParams, formParams, postBody, authNames, contentTypes, accepts, returnType, null, callback);
    }
    /**
     * Callback function to receive the result of the getModules operation.
     * @callback module:api/DefaultApi~getModulesCallback
     * @param {String} error Error message, if any.
     * @param {Array.<module:model/Module>} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * Gets a list of modules given an id
     * Returns a list of modules
     * @param {String} vasid 
     * @param {module:api/DefaultApi~getModulesCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link Array.<module:model/Module>}
     */

  }, {
    key: "getModules",
    value: function getModules(vasid, callback) {
      var postBody = null; // verify the required parameter 'vasid' is set

      if (vasid === undefined || vasid === null) {
        throw new _Error["default"]("Missing the required parameter 'vasid' when calling getModules");
      }

      var pathParams = {
        'vasid': vasid
      };
      var queryParams = {};
      var headerParams = {};
      var formParams = {};
      var authNames = ['bearerAuth'];
      var contentTypes = [];
      var accepts = ['application/json'];
      var returnType = [_Module["default"]];
      return this.apiClient.callApi('/v0/modules/{vasid}', 'GET', pathParams, queryParams, headerParams, formParams, postBody, authNames, contentTypes, accepts, returnType, null, callback);
    }
    /**
     * Callback function to receive the result of the getTestCodes operation.
     * @callback module:api/DefaultApi~getTestCodesCallback
     * @param {String} error Error message, if any.
     * @param {Array.<module:model/TestCode>} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * Gets a list of test codes given an id
     * Returns a list of test codes
     * @param {String} vasid 
     * @param {module:api/DefaultApi~getTestCodesCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link Array.<module:model/TestCode>}
     */

  }, {
    key: "getTestCodes",
    value: function getTestCodes(vasid, callback) {
      var postBody = null; // verify the required parameter 'vasid' is set

      if (vasid === undefined || vasid === null) {
        throw new _Error["default"]("Missing the required parameter 'vasid' when calling getTestCodes");
      }

      var pathParams = {
        'vasid': vasid
      };
      var queryParams = {};
      var headerParams = {};
      var formParams = {};
      var authNames = ['bearerAuth'];
      var contentTypes = [];
      var accepts = ['application/json'];
      var returnType = [_TestCode["default"]];
      return this.apiClient.callApi('/v0/testcodes/{vasid}', 'GET', pathParams, queryParams, headerParams, formParams, postBody, authNames, contentTypes, accepts, returnType, null, callback);
    }
    /**
     * Callback function to receive the result of the listCustomers operation.
     * @callback module:api/DefaultApi~listCustomersCallback
     * @param {String} error Error message, if any.
     * @param {Array.<module:model/Customer>} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * List all customers for current role
     * Returns an array all customers from a Management/Operations level.
     * @param {module:api/DefaultApi~listCustomersCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link Array.<module:model/Customer>}
     */

  }, {
    key: "listCustomers",
    value: function listCustomers(callback) {
      var postBody = null;
      var pathParams = {};
      var queryParams = {};
      var headerParams = {};
      var formParams = {};
      var authNames = ['bearerAuth'];
      var contentTypes = [];
      var accepts = ['application/json'];
      var returnType = [_Customer["default"]];
      return this.apiClient.callApi('/v0/customers', 'GET', pathParams, queryParams, headerParams, formParams, postBody, authNames, contentTypes, accepts, returnType, null, callback);
    }
    /**
     * Callback function to receive the result of the listFooterMenus operation.
     * @callback module:api/DefaultApi~listFooterMenusCallback
     * @param {String} error Error message, if any.
     * @param {Array.<module:model/MenuGroup>} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * List all menus for the UI Footer
     * Returns an array of all menus available to be rendered on the UI Footer.
     * @param {module:api/DefaultApi~listFooterMenusCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link Array.<module:model/MenuGroup>}
     */

  }, {
    key: "listFooterMenus",
    value: function listFooterMenus(callback) {
      var postBody = null;
      var pathParams = {};
      var queryParams = {};
      var headerParams = {};
      var formParams = {};
      var authNames = ['bearerAuth'];
      var contentTypes = [];
      var accepts = ['application/json'];
      var returnType = [_MenuGroup["default"]];
      return this.apiClient.callApi('/v0/ui-footer', 'GET', pathParams, queryParams, headerParams, formParams, postBody, authNames, contentTypes, accepts, returnType, null, callback);
    }
    /**
     * Callback function to receive the result of the listHeaderMenus operation.
     * @callback module:api/DefaultApi~listHeaderMenusCallback
     * @param {String} error Error message, if any.
     * @param {Array.<module:model/Menu>} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * List all menus for the UI Header
     * Returns an array all menus available to be rendered on the UI Header.
     * @param {module:api/DefaultApi~listHeaderMenusCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link Array.<module:model/Menu>}
     */

  }, {
    key: "listHeaderMenus",
    value: function listHeaderMenus(callback) {
      var postBody = null;
      var pathParams = {};
      var queryParams = {};
      var headerParams = {};
      var formParams = {};
      var authNames = ['bearerAuth'];
      var contentTypes = [];
      var accepts = ['application/json'];
      var returnType = [_Menu["default"]];
      return this.apiClient.callApi('/v0/ui-header', 'GET', pathParams, queryParams, headerParams, formParams, postBody, authNames, contentTypes, accepts, returnType, null, callback);
    }
    /**
     * Callback function to receive the result of the listOrgs operation.
     * @callback module:api/DefaultApi~listOrgsCallback
     * @param {String} error Error message, if any.
     * @param {Array.<module:model/Org>} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * List all orgs available to the current role
     * Returns an array all orgs available to be selected on the dashboard.
     * @param {String} userid 
     * @param {String} username 
     * @param {String} usertype 
     * @param {String} ecindicator 
     * @param {String} prodgroup 
     * @param {String} prodfamily 
     * @param {String} excludestatus 
     * @param {module:api/DefaultApi~listOrgsCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link Array.<module:model/Org>}
     */

  }, {
    key: "listOrgs",
    value: function listOrgs(userid, username, usertype, ecindicator, prodgroup, prodfamily, excludestatus, callback) {
      var postBody = null; // verify the required parameter 'userid' is set

      if (userid === undefined || userid === null) {
        throw new _Error["default"]("Missing the required parameter 'userid' when calling listOrgs");
      } // verify the required parameter 'username' is set


      if (username === undefined || username === null) {
        throw new _Error["default"]("Missing the required parameter 'username' when calling listOrgs");
      } // verify the required parameter 'usertype' is set


      if (usertype === undefined || usertype === null) {
        throw new _Error["default"]("Missing the required parameter 'usertype' when calling listOrgs");
      } // verify the required parameter 'ecindicator' is set


      if (ecindicator === undefined || ecindicator === null) {
        throw new _Error["default"]("Missing the required parameter 'ecindicator' when calling listOrgs");
      } // verify the required parameter 'prodgroup' is set


      if (prodgroup === undefined || prodgroup === null) {
        throw new _Error["default"]("Missing the required parameter 'prodgroup' when calling listOrgs");
      } // verify the required parameter 'prodfamily' is set


      if (prodfamily === undefined || prodfamily === null) {
        throw new _Error["default"]("Missing the required parameter 'prodfamily' when calling listOrgs");
      } // verify the required parameter 'excludestatus' is set


      if (excludestatus === undefined || excludestatus === null) {
        throw new _Error["default"]("Missing the required parameter 'excludestatus' when calling listOrgs");
      }

      var pathParams = {
        'userid': userid,
        'username': username,
        'usertype': usertype,
        'ecindicator': ecindicator,
        'prodgroup': prodgroup,
        'prodfamily': prodfamily,
        'excludestatus': excludestatus
      };
      var queryParams = {};
      var headerParams = {};
      var formParams = {};
      var authNames = ['bearerAuth'];
      var contentTypes = [];
      var accepts = ['application/json'];
      var returnType = [_Org["default"]];
      return this.apiClient.callApi('/v0/orgs/{ecindicator}/{prodgroup}/{prodfamily}/{excludestatus}', 'GET', pathParams, queryParams, headerParams, formParams, postBody, authNames, contentTypes, accepts, returnType, null, callback);
    }
  }]);

  return DefaultApi;
}();

exports["default"] = DefaultApi;